import React from "react";
import { useTranslation } from "react-i18next";

export function LocationSection() {
  const { t } = useTranslation();

  return (
    <section className="location-section">
      <div className="location-section-header">
        <h2>{t("locationTitle")}</h2>
      </div>

      <div className="location-section-content">
        <p>{t("locationAddress")}</p>

        <div className="location-section-map">
          <iframe
            title={t("locationMapTitle")}
            src={t("locationMapSrc")}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
